import { NgModule } from '@angular/core';
import { DefaultComponent } from '../pages/default/default.component';
import { HeaderNavComponent } from './header-nav/header-nav.component';
import { SubheaderTypeSearchComponent } from '../pages/subheader--type-search/subheader--type-search.component';
import { AsideNavComponent } from './aside-nav/aside-nav.component';
import { FooterComponent } from './footer/footer.component';
import { QuickSidebarComponent } from './quick-sidebar/quick-sidebar.component';
import { ScrollTopComponent } from './scroll-top/scroll-top.component';
import { TooltipsComponent } from './tooltips/tooltips.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HrefPreventDefaultDirective } from '../../_directives/href-prevent-default.directive';
import { UnwrapTagDirective } from '../../_directives/unwrap-tag.directive';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { FormsModule } from '@angular/forms';
import { CreateSiteComponent } from '../pages/default/shared/inventory/site/create-site/create-site.component';
import { UpdateSiteComponent } from '../pages/default/shared/inventory/site/update-site/update-site.component';
import { CreatePageComponent } from '../pages/default/shared/inventory/page/create-page/create-page.component';
import { UpdatePageComponent } from '../pages/default/shared/inventory/page/update-page/update-page.component';
import { CreateAdUnitComponent } from '../pages/default/shared/inventory/adunit/create-adunit/create-adunit.component';
import { UpdateAdUnitComponent } from '../pages/default/shared/inventory/adunit/update-adunit/update-adunit.component';
import { ListUserComponent } from '../pages/default/owner/owner-user/list-user/list-user.component';
import { CreateUserComponent } from '../pages/default/owner/owner-user/create-user/create-user.component';
import { UpdateUserComponent } from '../pages/default/owner/owner-user/update-user/update-user.component';
import { ListPublisherComponent } from '../pages/default/owner/publishers/list-publisher/list-publisher.component';
import { CreatePublisherComponent } from '../pages/default/owner/publishers/create-publisher/create-publisher.component';
import { UpdatePublisherComponent } from '../pages/default/owner/publishers/update-publisher/update-publisher.component';
import { PublisherDetailComponent } from '../pages/default/owner/publisher-detail/publisher-detail.component';
import { PublisherDetailSharedModule } from '../pages/default/owner/publisher-detail/publisher-detail.shared.module';
import { InventorySharedModule } from '../pages/default/shared/inventory/inventory.shared.module';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/multiselect.component';
import { CreatePublisherUserComponent } from '../pages/default/shared/publisher-user/create-publisher-user/create-publisherUser.component';
import { UpdatePublisherUserComponent } from '../pages/default/shared/publisher-user/update-publisher-user/update-publisherUser.component';
import { CreateUserGroupComponent } from '../pages/default/shared/user-group/create-user-group/create-user-group.component';
import { UpdateUserGroupComponent } from '../pages/default/shared/user-group/update-user-group/update-user-group.component';
import { ListSettingComponent } from '../pages/default/owner/setting/list-setting/list-setting.component';
import { UpdateSettingComponent } from '../pages/default/owner/setting/update-setting/update-setting.component';
import { SystemMessageComponent } from '../pages/default/publisher/system-message/system-message.component';
import { ListAgencyComponent } from '../pages/default/publisher/agency/list-agency/list-agency.component';
import { CreateAgencyComponent } from '../pages/default/publisher/agency/create-agency/create-agency.component';
import { UpdateAgencyComponent } from '../pages/default/publisher/agency/update-agency/update-agency.component';
import { ListCustomerComponent } from '../pages/default/publisher/customer/list-customer/list-customer.component';
import { CreateCustomerComponent } from '../pages/default/publisher/customer/create-customer/create-customer.component';
import { UpdateCustomerComponent } from '../pages/default/publisher/customer/update-customer/update-customer.component';
import { ReservationComponent } from '../pages/default/publisher/reservation/reservation.component';
import { ReservationCreateComponent } from '../pages/default/publisher/reservation/reservation-create/reservation-create.component';
import { ReservationSharedModule } from '../pages/default/publisher/reservation/reservation.shared.module';
import { DashboardComponent } from '../pages/default/publisher/dashboard/dashboard.component';

@NgModule({
    declarations: [
        DefaultComponent,
        HeaderNavComponent,
        SubheaderTypeSearchComponent,
        AsideNavComponent,
        FooterComponent,
        QuickSidebarComponent,
        ScrollTopComponent,
        TooltipsComponent,
        HrefPreventDefaultDirective,
        UnwrapTagDirective,
        BreadcrumbComponent,
        CreateSiteComponent,
        UpdateSiteComponent,
        CreatePageComponent,
        UpdatePageComponent,
        CreateAdUnitComponent,
        UpdateAdUnitComponent,
        ListUserComponent,
        CreateUserComponent,
        UpdateUserComponent,
        ListPublisherComponent,
        CreatePublisherComponent,
        UpdatePublisherComponent,
        PublisherDetailComponent,
        CreatePublisherUserComponent,
        UpdatePublisherUserComponent,
        CreateUserGroupComponent,
        UpdateUserGroupComponent,
        ListSettingComponent,
        UpdateSettingComponent,
        SystemMessageComponent,
        ListAgencyComponent,
        CreateAgencyComponent,
        UpdateAgencyComponent,
        ListCustomerComponent,
        CreateCustomerComponent,
        UpdateCustomerComponent,
        ReservationComponent,
        DashboardComponent
    ],
    exports: [
        DefaultComponent,
        HeaderNavComponent,
        SubheaderTypeSearchComponent,
        AsideNavComponent,
        FooterComponent,
        QuickSidebarComponent,
        ScrollTopComponent,
        TooltipsComponent,
        HrefPreventDefaultDirective
    ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        AngularMultiSelectModule,
        InventorySharedModule,
        PublisherDetailSharedModule,
        ReservationSharedModule
    ]
})
export class LayoutModule { }



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/layouts/layout.module.ts